import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    ErrorMessage,
    TextField,
    validationRules,
    EMAIL_TAKEN,
    clean,
    extractErrors,
} from '../../../Common/Form';
import { object } from 'yup';

const { firstName, lastName, email } = validationRules;

const schema = object({ firstName, lastName, email });

const StepOne = ({ collectData }) => {
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onSubmit = useCallback(
        (e) => {
            e.preventDefault();
            setIsSubmitting(true);

            const data = Object.fromEntries(new FormData(e.currentTarget).entries());

            schema
                .validate(data, { strict: true, abortEarly: false })
                .then(() => {
                    setErrors({});
                    collectData({
                        firstName: clean(data.firstName),
                        lastName: clean(data.lastName),
                        ...data,
                    });
                })
                .catch((errs) => {
                    setErrors(extractErrors(errs));
                    setIsSubmitting(false);
                });
        },
        [collectData]
    );

    return (
        <form onSubmit={onSubmit}>
            <p className="note">Note: your firm must have an account before you can register.</p>
            <div className="grid -col2 -form">
                <div className="grid__cell">
                    <TextField id="firstName" label="First Name" required />
                    <ErrorMessage message={errors.firstName ?? ''} />
                </div>
                <div className="grid__cell">
                    <TextField id="lastName" label="Last Name" required />
                    <ErrorMessage message={errors.lastName ?? ''} />
                </div>
            </div>
            <div>
                <TextField id="email" label="Corporate Email" required />
                <ErrorMessage message={errors.email && errors.email !== EMAIL_TAKEN ? errors.email : ''} />
            </div>
            <div className="grid -col2 -action -vAlignCenter">
                <div className="grid__cell">
                    Already have an account?
                    <a className="link -underline -dark -login" href="/login">
                        Login
                    </a>
                </div>

                <ErrorMessage
                    message={Object.keys(errors).length > 0 ? 'Please correct the invalid fields above.' : ''}
                />
                <ErrorMessage message={errors.email && errors.email === EMAIL_TAKEN ? EMAIL_TAKEN : ''} />

                <div className="grid__cell -button">
                    <Button name="signup" disabled={isSubmitting} text="Next" />
                </div>
            </div>
        </form>
    );
};

StepOne.propTypes = {
    collectData: PropTypes.func,
};

export default StepOne;
